import styled from 'styled-components';

// Components
import { ToastShell, ToastText } from '../shared/styles';

/**
 * Caja común (ver `../shared/styles.ts`); aquí solo el borde que lo distingue.
 *
 * Antes fijaba `width` y `height`, así que un mensaje de más de una línea salía
 * aplastado contra los bordes. Ahora el alto lo decide el contenido.
 */
export const Container = styled(ToastShell)`
  border: 1px solid ${({ theme }) => theme.colors.green};
`;

export const IconContainer = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Sin esto el icono se estrecha cuando el texto ocupa varias líneas. */
  flex-shrink: 0;
`;

export const Text = styled(ToastText)`
  margin-left: 1.2rem;
  color: ${({ theme }) => theme.colors.green};
`;
